import React, { useEffect, useState } from "react";
import { DEFAULT_ORCHESTRATOR_CONFIG_EXISTANCE, DEFAULT_WS_DATA } from "./constant";
import LOCAL_STORAGE_KEY from "../../service/local-storage/constant";
import SESSION_STORAGE_KEY from "../../service/session-storage/constant";

const UserContext = React.createContext({
    gdata: null,
    isOrchestratorConfigExistanceReceived: false,
    localSecret: "",
    orchestratorConfigExistance: null,
    setGdata: () => {},
    setOrchestratorConfigExistance: () => {},
    setOrchestratorConfigExistanceReceived: () => {},
    setLocalSecret: () => {},
    setWsData: () => {},
    wsData: null,
    progressTree:{},
    setProgressTree: () => {},
});

function UserContextProvider (props) {
    const { children } = props;
    const [gdata, setGdata] = useState({});
    const [wsData, setWsData] = useState(JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.WS_DATA)));
    const [localSecret, setLocalSecret] = useState(atob(sessionStorage.getItem(SESSION_STORAGE_KEY.LOCAL_SECRET) || ""));
    const [progressTree, setProgressTree] = useState({});
   

    // enter secret store password
    const [isOrchestratorConfigExistanceReceived, setOrchestratorConfigExistanceReceived] = useState(false);
    const [orchestratorConfigExistance, setOrchestratorConfigExistance] = useState(JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY.ORCHESTRATOR_CONFIG_EXISTANCE)));

    useEffect(() => {
        if (!wsData) {
            setWsData(DEFAULT_WS_DATA);

            localStorage.setItem(LOCAL_STORAGE_KEY.WS_DATA, JSON.stringify(DEFAULT_WS_DATA));
        }

        if (!orchestratorConfigExistance) {
            setOrchestratorConfigExistance(DEFAULT_ORCHESTRATOR_CONFIG_EXISTANCE);

            sessionStorage.setItem(SESSION_STORAGE_KEY.ORCHESTRATOR_CONFIG_EXISTANCE, JSON.stringify(DEFAULT_ORCHESTRATOR_CONFIG_EXISTANCE));
        }
    }, [orchestratorConfigExistance, wsData]);

    const context = {
        gdata,
        isOrchestratorConfigExistanceReceived,
        localSecret,
        orchestratorConfigExistance,
        setGdata,
        setLocalSecret,
        setOrchestratorConfigExistance,
        setOrchestratorConfigExistanceReceived,
        setWsData,
        wsData,
        progressTree,
        setProgressTree
    };

    return (
        <UserContext.Provider value={context}>
            {children}
        </UserContext.Provider>
    );
}

export { UserContext, UserContextProvider };
